import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Primary"] = "primary";
    ButtonVariant["Secondary"] = "secondary";
    ButtonVariant["Close"] = "close";
})(ButtonVariant || (ButtonVariant = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "small";
    ButtonSize["Large"] = "large";
})(ButtonSize || (ButtonSize = {}));
function Button({ variant, content, action, size = ButtonSize.Small }) {
    const isClose = variant === ButtonVariant.Close;
    const backgroundColor = isClose
        ? 'transparent'
        : variant === ButtonVariant.Primary
            ? '#3F51B5'
            : '#009688';
    // Size-based styling
    const isLarge = size === ButtonSize.Large;
    const fontSize = isClose ? '24pt' : (isLarge ? '20px' : '12px');
    const padding = isClose ? '0' : (isLarge ? '8px 16px' : '6px 12px');
    const borderRadius = isClose ? '0' : (isLarge ? '56px' : '50px');
    const width = isClose ? '30px' : 'auto';
    const height = isClose ? '30px' : 'auto';
    const buttonStyle = {
        backgroundColor,
        color: 'white',
        fontFamily: 'Cabin, sans-serif',
        fontSize,
        padding,
        borderRadius,
        border: 'none',
        cursor: 'pointer',
        transition: 'opacity 0.2s',
        width,
        height,
    };
    if (isClose) {
        buttonStyle.display = 'flex';
        buttonStyle.alignItems = 'center';
        buttonStyle.justifyContent = 'center';
    }
    return (_jsx("button", Object.assign({ onClick: action, style: buttonStyle, onMouseEnter: (e) => {
            e.currentTarget.style.opacity = '0.9';
        }, onMouseLeave: (e) => {
            e.currentTarget.style.opacity = '1';
        } }, { children: content })));
}
export default Button;
